<onyx-widget-box [heading]="`${I18N}.remainingToPayBack`">
  {{ remainingToPay() }}
</onyx-widget-box>
